<template>
  <loading v-if="isLoading"></loading>
  <not-found v-else-if="!item"></not-found>
  <no-auth v-else-if="!hasAuthorize.getById"></no-auth>
  <div v-else class="container-fluid o-card">
    <h4
      class="u-margin-bottom-small u-margin-bottom u-padding-right-small u-padding-left-xsmall"
    >
      {{ item.title }}
      <div>
        <small>{{ $date.format(item.createdDate || new Date()) }}</small>
      </div>
    </h4>
    <hr />

    <div class="row">
      <div
        class="es-xs-12"
        :class="{
          'es-sm-3': !creatingPdf,
          'u-padding-right-small u-padding-left-small es-sm-6': creatingPdf,
        }"
      >
        <div class="u-margin-bottom-small o-card__padding-small">
          <h6 class="u-margin-bottom-xsmall">
            {{ $t("ehouseCalculating.inletData") }}
          </h6>
          <BaseInput
            v-model="item.requestLocationFactor"
            :label="$t('ehouseCalculating.locationFactor')"
            block
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            readonly
            step="0.0001"
            suffix="m"
            type="number"
            :placeholder="$t('ehouseCalculating.locationFactor')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="item.requestAtmosphericPressure"
            :label="$t('ehouseCalculating.atmosphericPressure')"
            block
            step="0.0001"
            suffix="kPa"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            readonly
            type="number"
            :placeholder="$t('ehouseCalculating.atmosphericPressure')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="item.requestAmbientTemperature"
            :label="$t('ehouseCalculating.ambientTemperature')"
            block
            step="0.0001"
            suffix="°C"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            readonly
            type="number"
            :placeholder="$t('ehouseCalculating.ambientTemperature')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="item.requestAmbientHumidity"
            :label="$t('ehouseCalculating.ambientHumidity')"
            block
            step="0.0001"
            suffix="%"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            readonly
            type="number"
            :placeholder="$t('ehouseCalculating.ambientHumidity')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="item.requestRadiationPower"
            :label="$t('ehouseCalculating.radiationPower')"
            block
            step="0.0001"
            suffix="W/m²"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            readonly
            type="number"
            :placeholder="$t('ehouseCalculating.radiationPower')"
            mandotary
          ></BaseInput>
        </div>
        <div
          class="u-margin-bottom-small u-background-color-filtered o-card__padding-small"
        >
          <h6 class="u-margin-bottom-xsmall">
            {{ $t("ehouseCalculating.geometricParameters") }}
          </h6>
          <BaseInput
            v-model="item.requestLength"
            :label="$t('ehouseCalculating.length')"
            block
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            readonly
            type="number"
            step="0.0001"
            suffix="mm"
            :placeholder="$t('ehouseCalculating.length')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="item.requestWidth"
            :label="$t('ehouseCalculating.width')"
            block
            step="0.0001"
            suffix="mm"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            readonly
            type="number"
            :placeholder="$t('ehouseCalculating.width')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="item.requestHeight"
            :label="$t('ehouseCalculating.height')"
            block
            step="0.0001"
            suffix="mm"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            readonly
            type="number"
            :placeholder="$t('ehouseCalculating.height')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="item.requestNumberOfDoors"
            :label="$t('ehouseCalculating.numberOfDoors')"
            block
            :step="0.0001"
            :suffix="$t('common.pcs')"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            readonly
            type="number"
            :placeholder="$t('ehouseCalculating.numberOfDoors')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="item.requestElectricalInletOutlet"
            :label="$t('ehouseCalculating.electricalInletOutlet')"
            block
            step="0.0001"
            :suffix="$t('common.pcs')"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            readonly
            type="number"
            :placeholder="$t('ehouseCalculating.electricalInletOutlet')"
            mandotary
          ></BaseInput>
        </div>
        <div class="u-margin-bottom-small o-card__padding-small">
          <h6 class="u-margin-bottom-xsmall">
            {{ $t("ehouseCalculating.mainRoomAirConditions") }}
          </h6>
          <BaseInput
            v-model="item.requestAirTemperature"
            :label="$t('ehouseCalculating.airTemperature')"
            block
            :step="0.0001"
            suffix="°C"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            readonly
            type="number"
            :placeholder="$t('ehouseCalculating.airTemperature')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="item.requestRelativeHumidity"
            :label="$t('ehouseCalculating.relativeHumidity')"
            block
            step="0.0001"
            suffix="%"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            readonly
            type="number"
            :placeholder="$t('ehouseCalculating.relativeHumidity')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="item.requestHeatGeneration"
            :label="$t('ehouseCalculating.heatGeneration')"
            block
            step="0.0001"
            suffix="kW"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            readonly
            type="number"
            :placeholder="$t('ehouseCalculating.heatGeneration')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="item.requestRequiredPressurization"
            :label="$t('ehouseCalculating.requiredPressurization')"
            block
            step="0.0001"
            suffix="Pa"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            readonly
            type="number"
            :placeholder="$t('ehouseCalculating.requiredPressurization')"
            mandotary
          ></BaseInput>
          <BaseInput
            v-model="item.requestRequiredPressurizationStandard"
            :label="$t('ehouseCalculating.requiredPressurizationStandard')"
            block
            readonly
            step="0.0001"
            suffix="Pa"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :size="creatingPdf ? 'sm' : 'xs'"
            type="number"
            :placeholder="
              $t('ehouseCalculating.requiredPressurizationStandard')
            "
            mandotary
          ></BaseInput>
        </div>
      </div>
      <div
        class="es-xs-12"
        :class="{
          'es-sm-5 u-background-color-filtered o-card__padding-small':
            !creatingPdf,
          'u-padding-right-small u-padding-left-small': creatingPdf,
        }"
      >
        <h6 class="u-margin-bottom-xsmall">
          {{ $t("ehouseCalculating.wallsConstructionDetails") }}
        </h6>
        <div class="row">
          <div class="es-xs-6">
            <p>
              <small>
                {{ $t("ehouseCalculating.innerSideHeatConvectionCoefficient") }}
              </small>
            </p>
          </div>
          <div class="es-xs-3">
            <BaseInput
              :value="0"
              readonly
              disabled
              class="u-margin-0"
              block
              :size="creatingPdf ? 'sm' : 'xs'"
              step="0.0001"
              suffix="mm"
            ></BaseInput>
          </div>
          <div class="es-xs-3">
            <BaseInput
              :value="8"
              readonly
              disabled
              class="u-margin-0"
              block
              :size="creatingPdf ? 'sm' : 'xs'"
              step="0.0001"
              suffix="W/m.K"
            ></BaseInput>
          </div>
        </div>
        <div class="row">
          <div class="es-xs-6">
            <GetMetallicMaterials
              :class="{
                'c-form-control__variant--xs u-display-flex u-align-items-center u-justify-content-space-between u-margin-0 u-flex-1-with-child':
                  !creatingPdf,
              }"
              v-model="item.requestSteelPlateThermalConductivity"
              disabled
              :label="$t('ehouseCalculating.metallicMaterial')"
            ></GetMetallicMaterials>
          </div>
          <div class="es-xs-3">
            <BaseInput
              v-model="item.requestSteelPlateThickness"
              class="u-margin-0"
              block
              :size="creatingPdf ? 'sm' : 'xs'"
              readonly
              step="0.0001"
              suffix="mm"
            ></BaseInput>
          </div>
          <div class="es-xs-3">
            <BaseInput
              :value="54"
              readonly
              disabled
              class="u-margin-0"
              block
              :size="creatingPdf ? 'sm' : 'xs'"
              step="0.0001"
              suffix="W/m.K"
            ></BaseInput>
          </div>
        </div>
        <div class="row">
          <div class="es-xs-6">
            <GetInsulationMaterials
              v-model="item.requestAsbestosThermalConductivity"
              disabled
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-0 u-flex-1-with-child"
              :class="{ 'c-form-control__variant--xs': !creatingPdf }"
              :label="$t('ehouseCalculating.insulationMaterial')"
            ></GetInsulationMaterials>
          </div>
          <div class="es-xs-3">
            <BaseInput
              v-model="item.requestAsbestosThickness"
              class="u-margin-0"
              block
              readonly
              :size="creatingPdf ? 'sm' : 'xs'"
              step="0.0001"
              suffix="mm"
            ></BaseInput>
          </div>
          <div class="es-xs-3">
            <BaseInput
              :value="0.154"
              readonly
              class="u-margin-0"
              block
              :size="creatingPdf ? 'sm' : 'xs'"
              step="0.0001"
              suffix="W/m.K"
            ></BaseInput>
          </div>
        </div>
        <div class="row">
          <div class="es-xs-6">
            <GetBuildingMaterials
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-0 u-flex-1-with-child"
              :class="{ 'c-form-control__variant--xs': !creatingPdf }"
              v-model="item.requestNoneMaterialThermalConductivity"
              disabled
              :label="$t('ehouseCalculating.buildingMaterial')"
            ></GetBuildingMaterials>
          </div>
          <div class="es-xs-3">
            <BaseInput
              v-model="item.requestNoneMaterialThickness"
              class="u-margin-0"
              block
              readonly
              :size="creatingPdf ? 'sm' : 'xs'"
              step="0.0001"
              suffix="mm"
            ></BaseInput>
          </div>
          <div class="es-xs-3">
            <BaseInput
              :value="1"
              readonly
              disabled
              class="u-margin-0"
              block
              :size="creatingPdf ? 'sm' : 'xs'"
              step="0.0001"
              suffix="W/m.K"
            ></BaseInput>
          </div>
        </div>
        <div class="row u-align-items-flex-end">
          <div class="es-xs-6">
            <GetBuildingMaterials
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-0 u-flex-1-with-child"
              :class="{ 'c-form-control__variant--xs': !creatingPdf }"
              v-model="item.requestPvcThermalConductivity"
              disabled
              :label="$t('ehouseCalculating.buildingMaterial') + ' 2'"
            ></GetBuildingMaterials>
          </div>
          <div class="es-xs-3">
            <BaseInput
              v-model="item.requestPvcThickness"
              class="u-margin-0"
              block
              readonly
              :size="creatingPdf ? 'sm' : 'xs'"
              step="0.0001"
              suffix="mm"
            ></BaseInput>
          </div>
          <div class="es-xs-3">
            <BaseInput
              :value="0.23"
              readonly
              disabled
              class="u-margin-0"
              block
              :size="creatingPdf ? 'sm' : 'xs'"
              step="0.0001"
              suffix="W/m.K"
            ></BaseInput>
          </div>
        </div>
        <div class="row">
          <div class="es-xs-6">
            <p>
              <small>
                {{ $t("ehouseCalculating.outerSideHeatConvectionCoefficient") }}
              </small>
            </p>
          </div>
          <div class="es-xs-3">
            <BaseInput
              :value="0"
              readonly
              disabled
              class="u-margin-0"
              block
              :size="creatingPdf ? 'sm' : 'xs'"
              step="0.0001"
              suffix="mm"
            ></BaseInput>
          </div>
          <div class="es-xs-3">
            <BaseInput
              :value="23"
              readonly
              disabled
              class="u-margin-0"
              block
              :size="creatingPdf ? 'sm' : 'xs'"
              step="0.0001"
              suffix="W/m.K"
            ></BaseInput>
          </div>
        </div>
        <div class="u-margin-bottom">
          <img
            src="@/assets/images/ehouse-sema.png"
            :width="creatingPdf ? '70%' : '100%'"
            alt="ehouse sema"
          />
        </div>
      </div>
      <div
        class="es-xs-12"
        :class="{
          'es-sm-4 o-card__padding-small': !creatingPdf,
          'u-padding-right-small u-padding-left-small es-sm-6': creatingPdf,
        }"
      >
        <h6 class="u-margin-bottom-xsmall">
          {{ $t("ehouseCalculating.result") }}
        </h6>
        <div class="u-background-color-white o-card__padding-small">
          <div>
            <BaseInput
              v-model="item.responseWallsCeilingFloorHeatTransfer"
              :label="$t('ehouseCalculating.wallsCeilingFloorHeatTransfer')"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              block
              readonly
              disabled
              step="0.0001"
              suffix="W/m².K"
              :size="creatingPdf ? 'sm' : 'xs'"
              :value="10"
            ></BaseInput>
          </div>
          <div>
            <BaseInput
              v-model="item.responseHeatTransmission"
              :label="$t('ehouseCalculating.heatTransmission')"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              block
              readonly
              disabled
              step="0.0001"
              suffix="kW"
              :size="creatingPdf ? 'sm' : 'xs'"
              :value="15"
            ></BaseInput>
          </div>
          <div>
            <BaseInput
              v-model="item.responseHeatRadiation"
              :label="$t('ehouseCalculating.heatRadiation')"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              block
              readonly
              disabled
              step="0.0001"
              suffix="kW"
              :size="creatingPdf ? 'sm' : 'xs'"
              :value="1473.15"
            >
            </BaseInput>
          </div>
          <div>
            <BaseInput
              v-model="item.responseHeatDevices"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              block
              readonly
              disabled
              :size="creatingPdf ? 'sm' : 'xs'"
              :label="$t('ehouseCalculating.heatDevices')"
              :value="40"
              step="0.0001"
              suffix="kW"
            ></BaseInput>
          </div>
          <div>
            <BaseInput
              v-model="item.responseFreshAirHeatGain"
              :label="$t('ehouseCalculating.freshAirHeatGain')"
              block
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              readonly
              disabled
              step="0.0001"
              suffix="kW"
              :size="creatingPdf ? 'sm' : 'xs'"
              :value="973.15"
            >
            </BaseInput>
          </div>
          <div>
            <BaseInput
              v-model="item.responseAirFlow"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              block
              readonly
              disabled
              :size="creatingPdf ? 'sm' : 'xs'"
              :label="$t('ehouseCalculating.airFlow')"
              :value="24984.038"
              step="0.0001"
              suffix=""
            ></BaseInput>
          </div>
          <BaseInput
            v-model="item.responseAirFlowInfiltration"
            class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
            :label="$t('ehouseCalculating.airFlowInfiltration')"
            block
            readonly
            disabled
            :size="creatingPdf ? 'sm' : 'xs'"
            :value="29.83"
          ></BaseInput>

          <div>
            <BaseInput
              v-model="item.responseCondensateWater"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :label="$t('ehouseCalculating.condensateWater')"
              block
              readonly
              disabled
              step="0.0001"
              :size="creatingPdf ? 'sm' : 'xs'"
              :value="0.11"
            ></BaseInput>
          </div>
          <div>
            <BaseInput
              v-model="item.responseHeatCalculated"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :label="$t('ehouseCalculating.heatCalculated')"
              block
              readonly
              disabled
              step="0.0001"
              suffix="kW"
              :size="creatingPdf ? 'sm' : 'xs'"
              :value="58.24"
            ></BaseInput>
          </div>
          <div>
            <BaseInput
              v-model="item.responseTotalHeatGain"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :label="$t('ehouseCalculating.totalHeatGain')"
              block
              readonly
              disabled
              suffix="kW"
              :size="creatingPdf ? 'sm' : 'xs'"
              :value="64.07"
            >
            </BaseInput>
          </div>
          <div>
            <BaseInput
              v-model="item.responseAdditionalHumidityRequired"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :label="$t('ehouseCalculating.additionalHumidityRequired')"
              block
              readonly
              disabled
              step="0.0001"
              suffix=""
              :size="creatingPdf ? 'sm' : 'xs'"
              :value="27.01"
            ></BaseInput>
          </div>
          <div>
            <BaseInput
              v-model="item.responseSafetyFactor"
              class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
              :label="$t('ehouseCalculating.safetyFactor')"
              block
              readonly
              disabled
              step="0.0001"
              suffix="%"
              :size="creatingPdf ? 'sm' : 'xs'"
              :value="10"
            ></BaseInput>
          </div>

          <Button
            block
            v-if="!creatingPdf"
            variant="danger "
            class="u-margin-top"
            @click="creatingPdf = true"
          >
            {{ $t("common.printCalculation") }}
          </Button>

          <router-link v-if="!creatingPdf" :to="{ name: 'cycles-selection' }">
            <Button block variant="primary" class="u-margin-top">
              {{ $t("cycles.selection2") }}
            </Button>
          </router-link>
        </div>
      </div>
    </div>
    <ExportPdf
      v-if="creatingPdf"
      auto-export
      :form="item"
      @pdfCreated="creatingPdf = false"
    />
  </div>
</template>

<script>
import Requests from "@/services/Requests";
import Loading from "../../Base/Loading/Loading.vue";
import NotFound from "../../Base/NotFound.vue";
import html2pdf from "html2pdf.js";
import BaseInput from "@/components/Base/Inputs/BaseInput.vue";
import Button from "@/components/Base/Button.vue";
import GetBuildingMaterials from "./Searches/GetBuildingMaterials.vue";
import GetInsulationMaterials from "./Searches/GetInsulationMaterials.vue";
import GetMetallicMaterials from "./Searches/GetMetallicMaterials.vue";
import authorize from "./authorize";
import ExportPdf from "./ExportPdf.vue";
export default {
  mixins: [authorize],
  components: {
    Loading,
    NotFound,
    BaseInput,
    Button,
    GetMetallicMaterials,
    GetInsulationMaterials,
    GetBuildingMaterials,
    ExportPdf,
  },
  data() {
    return {
      cycleId: null,
      isLoading: true,
      cycle: null,
      creatingPdf: false,
      item: {},
    };
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    result: {
      type: Object,
      required: true,
    },
    autoPrint: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    setForm() {
      this.item = {
        title: this.title || this.$t("ehouseCalculating.mainTitle"),
        requestPvcThickness: this.form.pvcThickness,
        requestPvcThermalConductivity: this.form.pvcThermalConductivity,
        requestNoneMaterialThickness: this.form.noneMaterialThickness,
        requestNoneMaterialThermalConductivity:
          this.form.noneMaterialThermalConductivity,
        requestSteelPlateThickness: this.form.steelPlateThickness,
        requestSteelPlateThermalConductivity:
          this.form.steelPlateThermalConductivity,
        requestAsbestosThickness: this.form.asbestosThickness,
        requestAsbestosThermalConductivity:
          this.form.asbestosThermalConductivity,
        requestAirTemperature: this.form.airTemperature,
        requestRelativeHumidity: this.form.relativeHumidity,
        requestHeatGeneration: this.form.heatGeneration,
        requestRequiredPressurization: this.form.requiredPressurization,
        requestRequiredPressurizationStandard:
          this.form.requiredPressurizationStandard,
        requestLocationFactor: this.form.locationFactor,
        requestAtmosphericPressure: this.form.atmosphericPressure,
        requestAmbientTemperature: this.form.ambientTemperature,
        requestAmbientHumidity: this.form.ambientHumidity,
        requestRadiationPower: this.form.radiationPower,
        requestLength: this.form.length,
        requestWidth: this.form.width,
        requestHeight: this.form.height,
        requestNumberOfDoors: this.form.numberOfDoors,
        requestElectricalInletOutlet: this.form.electricalInletOutlet,
        responseWallsCeilingFloorHeatTransfer:
          this.result.wallsCeilingFloorHeatTransfer,
        responseHeatTransmission: this.result.heatTransmission,
        responseHeatRadiation: this.result.heatRadiation,
        responseHeatDevices: this.result.heatDevices,
        responseFreshAirHeatGain: this.result.freshAirHeatGain,
        responseAirFlowInfiltration: this.result.airFlowInfiltration,
        responseCondensateWater: this.result.condensateWater,
        responseHeatCalculated: this.result.heatCalculated,
        responseTotalHeatGain: this.result.totalHeatGain,
        responseAdditionalHumidityRequired:
          this.result.additionalHumidityRequired,
        responseSafetyFactor: this.result.safetyFactor,
        responseAirFlow: this.result.airFlow,
        createdDate: new Date().toISOString(),
      };
      this.isLoading = false;
      this.createPdf();
    },
    async getItem() {
      if (this.autoPrint) return this.setForm();
      this.isLoading = true;
      const response = await Requests.HeatGain.GetById({
        params: {
          id: this.$route.params.id,
        },
      });
      if (response.message === "OK") {
        this.item = response.data;
      }
      this.isLoading = false;
    },
    async createPdfBlob() {
      const element = document.getElementById("ehouse-calculating-detail");
      const opt = {
        margin: [25, 1, 40, 1],
        filename: this.item.title + ".pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
      };

      const footerImg = "/pdf-footer.png";
      const headerImg = "/pdf-header.png";
      //const footerLogo = ;
      html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          var totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            // set footer to every page
            pdf.setPage(i);
            // set footer font
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            pdf.addImage(
              footerImg,
              "png",
              10,
              pdf.internal.pageSize.getHeight() - 30,
              pdf.internal.pageSize.getWidth() - 20,
              30
            );
            pdf.addImage(
              headerImg,
              "png",
              10,
              0,
              pdf.internal.pageSize.getWidth() - 20,
              25
            );
            // pdf.addImage(
            //   footerLogo,
            //   "png",
            //   0,
            //   0,
            //   pdf.internal.pageSize.getWidth(),
            //   0.3
            // );
          }
          window.open(pdf.output("bloburl"), "_blank");
          this.$store.dispatch("SET_ACTION_MODAL", {
            isLoading: false,
            status: false,
          });
          this.creatingPdf = false;
          this.$emit("pdfCreated");
        });
      return "";
    },
    blobToFile(blob, fileName) {
      return new File([blob], fileName, { type: "application/pdf" });
    },
    async createPdf() {
      this.creatingPdf = true;
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: true,
        status: true,
        message: this.$t("common.creatingPdf"),
        duration: 20 * 60 * 1000,
      });
      setTimeout(async () => {
        await this.createPdfBlob();
      }, 500);
    },
  },
  mounted() {
    this.getItem();
  },
};
</script>

<style scoped>
page {
  background: white;
  display: block;
  margin: 0 auto;
  position: relative;
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

page[size="A4"][layout="portrait"] {
  width: 29.7cm;
  height: 21cm;
}

@media print {
  body,
  page {
    margin: 0;
    box-shadow: 0;
  }
}

.page_header {
  position: running(header);
  width: 100%;
}

.page_footer {
  position: running(footer);
  width: 100%;
}

.pdf-content {
  padding: 20px;
}
</style>
